import styled from 'styled-components';

export const SlideoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 24px;
  gap: 16px;
`;

export const SlideoutHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SlideoutSubHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const BackButtonWrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  
  &:hover {
    opacity: 0.7;
  }
`;

export const SlideoutContent = styled.div`
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const SlideoutContentWrapper = styled.div`
  flex: 1;
  overflow-y: auto;
`;

export const SlideoutActions = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
  border-top: 1px solid ${(props) => props.theme.colors.border || '#e0e0e0'};
`;

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 0;
`;

export const ListItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 8px;
  background: ${(props) => props.theme.colors.surface || '#f5f5f5'};
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: ${(props) => props.theme.colors.surfaceHover || '#eeeeee'};
  }
`;

export const ListItemContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const ListItemMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
  gap: 8px;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 48px;
`;

export const SearchContainer = styled.div`
  margin-bottom: 8px;
`;

export const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-columns: 1fr;
  gap: ${(props) => props.theme.spacing?.md || '16px'};
  padding: 8px 0;
  
  > * {
    min-width: 0;
    width: 100%;
  }
`;

export const DocumentsCardsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${(props) => props.theme.spacing?.md || '16px'};
  padding: 8px 0;
  
  > * {
    min-width: 0;
    width: 100%;
  }
`;

